import { IWebsiteNeighbourhood } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

export class WebsiteBuilderItemNeighbourhood extends WebsiteBuilderItemBase {
    name = 'Neighbourhood';
    navName = 'Neighbourhood';
    navLink = 'neighbourhood';
    isShowInMenu = false;
    isHomePagePart = true;

    whatIsNearby: string = '';
    changedMap: any = null;
    streetViewEnabled: boolean = false;
    map: {
        lat: number;
        lng: number;
        zoom: number,
        pov: { heading: number, pitch: number, zoom: number }
    };
    lat: number = 43.641579;
    lng: number = -79.415903;
    changedLat: number = 43.641579;
    changedLng: number = -79.415903;
    zoom: number = 13;
    changedZoom: number = null;
    address: string = '';

    get isDisable(): boolean {
        return !this.address;
    }

    set value(item: IWebsiteNeighbourhood) {
        this.isPresent = item.status;
        this.map = JSON.parse(item.map);
        this.lat = this.map.lat;
        this.lng = this.map.lng;
        this.changedLat = this.map.lat;
        this.changedLng = this.map.lng;
        this.zoom = this.map.zoom;
        this.streetViewEnabled = !!item.streetView;
        this.whatIsNearby = item.nearby || '';
        this.address = item.address || '';
        this.priority = item.priority;
    }

    get value(): IWebsiteNeighbourhood {
        const map = {
            lng: this.changedLng || this.lng,
            lat: this.changedLat || this.lat,
            zoom: this.changedZoom || this.zoom,
            pov: (this.changedMap && this.changedMap.streetView) ? this.changedMap.streetView.pov : null,
        };

        return {
            map: JSON.stringify(map),
            streetView : this.streetViewEnabled ? 'true' : '',
            nearby: this.whatIsNearby,
            address: this.address,
            status: this.isPresent,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-neighbourhood.ts